import type { TranslationCatalog } from "../TranslationManager";

export const it: TranslationCatalog = {
  "labels.cardNumber": "Numero della carta",
  "labels.expirationDate": "Data di scadenza",
  "labels.cvc": "Codice di sicurezza",
  "placeholders.cardNumber": "1234 1234 1234 1234",
  "placeholders.expirationDate": "MM / AA",
  "placeholders.cvc": "CVV",
  "errors.invalidCardNumber": "Il numero della carta non è valido.",
  "errors.invalidExpiryDate": "La data di scadenza della carta non è valida.",
  "errors.invalidCvc": "Il codice di sicurezza della carta non è valido.",
  "errors.incompleteCardNumber": "Il numero della carta è incompleto.",
  "errors.incompleteExpiryDate": "La data di scadenza della carta è incompleta.",
  "errors.incompleteCvc": "Il codice di sicurezza della carta è incompleto.",
  "errors.expiredCard": "La carta è scaduta.",
  "aria.cardNumber": "Numero della carta",
  "aria.expirationDate": "Data di scadenza",
  "aria.cvc": "Codice di sicurezza",
  "aria.cardInput": "Informazioni della carta",
};
